import { type AxiosError, type AxiosResponse } from 'axios';

import { BaseLogger } from './BaseLogger';
import { LogDevMessageKinds } from './types';
import { getAxiosErrorMessage } from './utils/get-axios-error-message';

export class ApiLogger extends BaseLogger {
  static readonly retryInDevMode = this.makeLogFunction<AxiosError, number>(
    LogDevMessageKinds.retry,
    (error, retryCount) => `${this.formatTitle(error)} ~${retryCount}`,
    ['MESSAGE', (error) => getAxiosErrorMessage(error)],
    ['Error', (error) => error]
  );

  private static readonly apiErrorInDevMode = this.makeLogFunction<AxiosError, string>(
    LogDevMessageKinds.apiError,
    this.formatTitle,
    ['MESSAGE', (error) => getAxiosErrorMessage(error)],
    ['Error', (error) => error]
  );

  private static readonly apiResponseInDevMode = this.makeLogFunction<
    AxiosResponse,
    string
  >(LogDevMessageKinds.api, (response) => response.request?.responseURL ?? '', [
    'DATA',
    (response) => response.data,
  ]);

  static apiErrorLogger(error: AxiosError) {
    this.apiErrorInDevMode(error);
    return Promise.reject(error);
  }
  static apiSuccessLogger(response: AxiosResponse) {
    this.apiResponseInDevMode(response);
    return response;
  }
}
